module.exports = __webpack_public_path__ + "images/emoji/bee.5c9d6132112f0110044f.png";